<h1 class="mb-4">Formularz rejestracji nowego konta</h1>
<div class="flex flex-col gap-10">
  <p-card header="Dane osobowe">
    <app-form-beneficiary-details
      [formGroup]="formGroup().controls.details"
    ></app-form-beneficiary-details>
  </p-card>
  <p-card header="Dane kontaktowe">
    <app-form-beneficiary-contact-details
      [formGroup]="formGroup().controls.contactDetails"
    ></app-form-beneficiary-contact-details>
  </p-card>
  <app-form-edit-beneficiary-address
    [formGroup]="formGroup().controls.address"
  ></app-form-edit-beneficiary-address>
  <p-card header="Konto bankowe">
    <app-form-bank-account
      [formGroup]="formGroup().controls.kontoBankowe"
    ></app-form-bank-account>
  </p-card>
  <p-card>
    <div class="mb-2">
      <p-checkbox
        [formControl]="formGroup().controls.akceptacjaRegulaminu"
        [binary]="true"
        id="akceptacjaRegulaminu"
        inputId="akceptacjaRegulaminu"
        appControlError
        appendTo="body"
      />
      <label for="akceptacjaRegulaminu" class="ml-2"
        >Oświadczam, że akceptuję
        <span class="clickable-text" (click)="onRegulaminClick()"
          >Regulamin konta</span
        ></label
      >
    </div>
    <div class="mb-2">
      <p-checkbox
        [formControl]="formGroup().controls.akceptacjaRODO"
        [binary]="true"
        id="akceptacjaRODO"
        inputId="akceptacjaRODO"
        appControlError
        appendTo="body"
      />
      <label for="akceptacjaRODO" class="ml-2"
        >Wyrażam zgodę na gromadzenie, przetwarzanie i wykorzystywanie moich
        danych, teraz i w przyszłości, zgodnie z rozporządzeniem Parlamentu
        Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie
        ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w
        sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy
        95/46/WE (ogólne rozporządzenie o ochronie danych) (Dz. Urz. UE L 119 z
        04.05.2016) oraz przepisami ustawy z dnia 10 maja 2018 r. o ochronie
        danych osobowych w celach związanych z założeniem konta użytkownika,
        zarządzaniem nim oraz świadczeniem usług elektronicznych przez Ministra
        Rodziny, Pracy i Polityki Społecznej, którego urząd znajduje się przy
        ul. Nowogrodzkiej 1/3/5, w Warszawie. Jestem świadomy, że podanie danych
        jest dobrowolne, mam prawo wglądu do moich danych, ich poprawienia lub
        aktualizacji.</label
      >
    </div>
  </p-card>
</div>
<div class="flex justify-end mt-4 gap-4">
  <p-button
    styleClass="customInfoButton"
    label="Zatwierdź"
    (click)="save()"
  ></p-button>
  <p-button
    styleClass="customInfoButton"
    label="Anuluj"
    (click)="decline()"
  ></p-button>
</div>
